module.exports = __webpack_public_path__ + "static/media/no_break.aa2a4172.svg";